import {
  resolveStatementAttachmentHref,
  attachmentDisplayName,
} from '../utils/statementAttachments';

/**
 * Ссылки на файлы условия задачи (statement_attachments).
 */
export default function StatementAttachmentLinks({ attachments, className = '', variant = 'work' }) {
  if (!Array.isArray(attachments) || attachments.length === 0) return null;
  const items = attachments
    .map((att, i) => {
      const href = resolveStatementAttachmentHref(typeof att?.url === 'string' ? att.url : '');
      if (!href) return null;
      const label = attachmentDisplayName(att);
      const external = href.startsWith('http://') || href.startsWith('https://');
      return (
        <a
          key={`${href}-${i}`}
          href={href}
          download={external ? undefined : label}
          target={external ? '_blank' : undefined}
          rel={external ? 'noopener noreferrer' : undefined}
          className="statement-attachment-link"
        >
          {label}
        </a>
      );
    })
    .filter(Boolean);
  if (items.length === 0) return null;
  const rootClass =
    variant === 'catalog'
      ? `statement-attachment-links statement-attachment-links--catalog ${className}`.trim()
      : variant === 'detail'
        ? `statement-attachment-links statement-attachment-links--detail ${className}`.trim()
        : `statement-attachment-links statement-attachment-links--work ${className}`.trim();
  return (
    <div className={rootClass}>
      <span className="statement-attachment-links__label">Файлы:</span>
      <span className="statement-attachment-links__list">{items}</span>
    </div>
  );
}
